import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  TOUR_SHOWING_STATUS_FAILED,
} from 'common/tourConstants';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrCollapsibleRow from 'client/components/SrCollapsibleRow';
import SrDataTablePartnerStatTours from 'client/components/SrDataTablePartnerStatTours';
import SrDataTablePartnerStatSupraShowings from 'client/components/SrDataTablePartnerStatSupraShowings';

class SrPartnerStatsToursModal extends Component {
  static propTypes = {
    stats: PropTypes.object.isRequired,
    listingManagementCompany: PropTypes.string,
    listingId: PropTypes.number,
    apartmentId: PropTypes.number,
    sinceDate: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onRefreshStats: PropTypes.func.isRequired,
    locationQuery: PropTypes.object.isRequired,
  }

  render() {
    const {
      stats,
      listingManagementCompany,
      listingId,
      apartmentId,
      sinceDate,
      onClose,
      onRefreshStats,
      locationQuery,
    } = this.props;

    return (
      <SrDarkModal>
        <SrModalContent width={1340} onCloseIconClick={onClose}>
          <SrCollapsibleRow title={`Supra Showings (${stats.supraShowings} unique)`} collapsed>
            <SrDataTablePartnerStatSupraShowings
              listingManagementCompany={listingManagementCompany}
              listingId={listingId}
              apartmentId={apartmentId}
              onRefreshStats={onRefreshStats}
            />
          </SrCollapsibleRow>
          <SrCollapsibleRow
            title={`Failed Tours (${stats.toursFailed} unique)`}
            collapsed={locationQuery.openFailedTours !== 'true'}
          >
            <SrDataTablePartnerStatTours
              listingManagementCompany={listingManagementCompany}
              listingId={listingId}
              apartmentId={apartmentId}
              sinceDate={moment(sinceDate).toISOString()}
              onRefreshStats={onRefreshStats}
              tourStatus={TOUR_SHOWING_STATUS_FAILED}
            />
          </SrCollapsibleRow>
          <SrCollapsibleRow title={`Tours Completed (${stats.toursCompleted} unique)`} collapsed>
            <SrDataTablePartnerStatTours
              listingManagementCompany={listingManagementCompany}
              listingId={listingId}
              apartmentId={apartmentId}
              sinceDate={moment(sinceDate).toISOString()}
              onRefreshStats={onRefreshStats}
            />
          </SrCollapsibleRow>
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrPartnerStatsToursModal.displayName = 'SrPartnerStatsToursModal';

export default SrPartnerStatsToursModal;
